export default {
  SET_QUERY(state, payload) {
    state.query = payload;
  },
  SET_STATUS_FILTER(state, payload) {
    state.statusFilter = payload;
  },
  SET_SORTING(state, { sortColumnName, sortDirection }) {
    state.cameras.sort_column_name = sortColumnName;
    state.cameras.sort_direction = sortDirection;
  },
  SET_CAMERA(state, payload) {
    state.camera = payload;
  },
  SET_CAMERA_PARAMETER(state, payload) {
    state.camera = {
      ...state.camera,
      ...payload,
    };
  },
  SET_CAMERA_LOADING(state, status) {
    state.loadingCamera = status;
  },
  SET_CAMERAS_LIST_LOADING(state, status) {
    state.camerasListLoading = status;
  },
  SET_LIST_CAMERAS(state, payload) {
    state.cameras.data = payload.data;
    state.cameras.total = payload.total;
    state.cameras.count = payload.count;
  },
  SET_CAMERAS_PARAMETERS(state, payload) {
    state.cameras.parameters = payload;
  },
  SET_LIST_PUSH_CAMERAS_APPEND(state, payload) {
    const items = state.cameras.data;
    state.cameras.data = items.concat(payload.data);
  },
  SET_CAMERA_RECIPIENTS(state, recipients = []) {
    state.recipients = recipients;
  },
  SET_CONFIG(state, config = {}) {
    state.config = config;
  },
  SET_MODEL(state, model) {
    state.model = model;
  },
  SET_CAMERA_AGENT_STATUS(state, agent_status) {
    state.agent_status = agent_status;
  },
  SET_CAMERA_STREAMS_URLS(state, urls = {}) {
    state.cameraStreamsUrls = urls;
  },
  SET_CAMERA_PUBLISH_URLS(state, payload) {
    state.camera.publish_urls = payload;
  },
};
